import { useState } from "react";
import { newsList } from "@/mocks/news";
import Breadcrumb from "@/components/feature/Breadcrumb";
import NewsCard from "@/components/feature/NewsCard";
import EmptyState from "@/components/feature/EmptyState";
import { usePageMeta } from "@/hooks/usePageMeta";

const wrap = "mx-auto w-full max-w-[1280px] px-4 md:px-6";

const filters = [
  { value: "all", label: "全部" },
  { value: "新闻", label: "新闻" },
  { value: "专题", label: "专题" },
  { value: "报道", label: "报道" },
];

export default function NewsPage() {
  const [active, setActive] = useState("all");
  usePageMeta(
    "影视资讯 - 泰剧腐剧双男主",
    "汇总最新的泰国双男主影视新闻、行业专题与幕后报道，第一时间了解泰剧动态。",
  );

  const list = active === "all" ? newsList : newsList.filter((n) => n.category === active);

  return (
    <div className={wrap}>
      <div className="border-b border-background-200 pt-6 pb-5">
        <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "影视资讯" }]} />
        <h1 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">影视资讯</h1>
        <p className="mt-2 max-w-3xl text-sm leading-relaxed text-foreground-600">
          汇总最新的泰国双男主影视新闻、行业观察与幕后报道，帮你在追剧之余了解作品背后的故事。
        </p>
        <div className="mt-4 inline-flex items-center gap-1 rounded-full border border-background-200 bg-background-100 p-1">
          {filters.map((f) => (
            <button
              key={f.value}
              type="button"
              onClick={() => setActive(f.value)}
              className={`rounded-full px-4 py-1.5 text-sm transition-colors cursor-pointer whitespace-nowrap ${
                active === f.value
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-600 hover:text-primary-600"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-6 pb-4">
        {list.length > 0 ? (
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {list.map((item, i) => (
              <NewsCard key={item.id} item={item} index={i} />
            ))}
          </div>
        ) : (
          <EmptyState
            icon="ri-newspaper-line"
            title="该分类暂无资讯"
            description="换个分类看看，或稍后再来查看最新内容。"
            actionLabel="查看全部资讯"
            onAction={() => setActive("all")}
          />
        )}
      </div>
    </div>
  );
}